module.exports = __webpack_public_path__ + "media/images/icon_contact-214852d71783ab346d77a6629a34fca5.svg";